import React from 'react';
import PrintIcon from '../../icons/IconLib/PrintIcon';
import { IPrintersItem } from '../../../modules/API/Defaults/models/printers';
import SearchableSelect from '../SearchableSelect/SearchableSelect';

interface Props {
    printers: IPrintersItem[];
    value: IPrintersItem | null;
    onSelect: (printer: IPrintersItem | null) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    className?: string;
}

const PrinterSelector: React.FC<Props> = ({
    printers,
    value,
    onSelect,
    placeholder = 'בחר מדפסת',
    disabled,
    readOnly,
    className,
}) => (
    <SearchableSelect<IPrintersItem>
        items={printers}
        value={value}
        onSelect={onSelect}
        getKey={(p) => p.NumWeight}
        getLabel={(p) => (p.DescWeights ?? '').trim()}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        leadingIcon={<PrintIcon />}
        className={className}
        emptyLabel='אין מדפסות מתאימות'
    />
);

export default PrinterSelector;
